import { on } from 'delegated-events'
import { Swiper, Pagination, Autoplay, Lazy } from 'swiper'

Swiper.use([Pagination, Autoplay, Lazy])

const lightGallery = window.lightGallery

const swipers = {}

const fn = {
  init: () => {
    document.querySelectorAll('.photo-gallery-grid-slider').forEach((el) => fn.setupSlider(el))

    on('click', '[data-gallery-trigger]', fn.handleTrigger)
  },

  setupSlider: (el) => {
    const container = el.querySelector('.swiper-container')
    const numSlides = container.querySelectorAll('.swiper-slide').length
    const id = Math.floor(Math.random() * 1000)

    el.dataset.swiperId = id

    const opts = {
      spaceBetween: 8,
      speed: 500,
      autoplay: {
        delay: 6000,
      },
      slidesPerView: 1,
      pagination: {
        el: el.querySelector('.swiper-pagination'),
        type: 'bullets',
        clickable: true,
      },
      breakpoints: {
        768: {
          spaceBetween: 16,
        },
      },
      preloadImages: false,
      watchSlidesVisibility: true,
      lazy: {
        loadPrevNext: true,
      },
    }

    if (numSlides > 1) {
      swipers[id] = new Swiper(container, opts)
    }
  },

  handleTrigger: (e) => {
    e.preventDefault()

    const swiperId = e.target.closest('.photo-gallery-grid-slider').dataset.swiperId
    const gallery = e.target.closest('[data-photo-gallery]')
    const startIndex = e.currentTarget.dataset.galleryIndex || 0
    const galleryData = JSON.parse(gallery.dataset.photoGallery)

    if (swiperId in swipers) {
      swipers[swiperId].autoplay.stop()
    }

    lightGallery(gallery, {
      index: parseInt(startIndex),
      dynamic: true,
      dynamicEl: galleryData,
      thumbnail: true,
      download: false,
    })

    gallery.addEventListener(
      'onCloseAfter',
      () => {
        const uid = gallery.getAttribute('lg-uid')

        if (Object.prototype.hasOwnProperty.call(window.lgData, uid)) {
          window.lgData[uid].destroy(true)
        }

        if (swiperId in swipers) {
          swipers[swiperId].autoplay.start()
        }
      },
      { once: true }
    )
  },
}

export default {
  can: () => true,
  run: fn.init,
}
